export const COLORES_GIFTCARD = {
  pendiente: { bg: '#e0e7ff', color: '#3730a3' }, // vendida, esperando recibo y factura
  activa: { bg: '#dcfce7', color: '#166534' },
  agotada: { bg: '#f1f5f9', color: '#475569' },
  vencida: { bg: '#fef3c7', color: '#92400e' },
  anulada: { bg: '#fee2e2', color: '#991b1b' },
}

export const LABELS_GIFTCARD = {
  pendiente: 'Pendiente de pago',
  activa: 'Activa',
  agotada: 'Agotada',
  vencida: 'Vencida',
  anulada: 'Anulada',
}

export default function EstadoBadgeGiftCard({ estado }) {
  const c = COLORES_GIFTCARD[estado] || { bg: '#f1f5f9', color: '#475569' }

  return (
    <span style={{
      display: 'inline-block',
      background: c.bg, color: c.color, padding: '2px 8px', borderRadius: 4,
      fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.02em',
      whiteSpace: 'nowrap',
    }}>
      {LABELS_GIFTCARD[estado] || estado}
    </span>
  )
}
